import { useUserRole } from '@/store/authStore'

interface TermForm {
  lower: string
  title: string
  upper: string
  lowerPlural: string
  titlePlural: string
  upperPlural: string
}

interface Terminology {
  course: TermForm
  lesson: TermForm
}

const pirate: Terminology = {
  course: {
    lower: 'adventure',
    title: 'Adventure',
    upper: 'ADVENTURE',
    lowerPlural: 'adventures',
    titlePlural: 'Adventures',
    upperPlural: 'ADVENTURES',
  },
  lesson: {
    lower: 'mission',
    title: 'Mission',
    upper: 'MISSION',
    lowerPlural: 'missions',
    titlePlural: 'Missions',
    upperPlural: 'MISSIONS',
  },
}

const instructor: Terminology = {
  course: {
    lower: 'course',
    title: 'Course',
    upper: 'COURSE',
    lowerPlural: 'courses',
    titlePlural: 'Courses',
    upperPlural: 'COURSES',
  },
  lesson: {
    lower: 'lesson',
    title: 'Lesson',
    upper: 'LESSON',
    lowerPlural: 'lessons',
    titlePlural: 'Lessons',
    upperPlural: 'LESSONS',
  },
}

function getTerminology(role?: string): Terminology {
  if (role === 'captain' || role === 'admin') return instructor
  return pirate
}

export function useTerminology(): Terminology {
  const role = useUserRole()
  return getTerminology(role)
}
